import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardActions, Container } from "@mui/material";
import Certificate from "./Certificate";
import FileSaver from "file-saver";
import MediaViewer from "../../../Common/Media/MediaViewer";

import { downloadCertificate } from "../../../../actions/tmsActions";
import { getApplication } from "../../../../reducers";

const appCode = 'C-TMS';


export default function Accomplishment({ match }) {
    const { serviceURL } = useSelector((state) => getApplication(state, appCode));
    const dispatch = useDispatch();
    const handleDownload = () => dispatch(downloadCertificate(appCode, match.params.id, (blob) => FileSaver.saveAs(blob, 'Certificate.pdf')));

    return (
        <Container className="content">
            <Card className="card">
                <CardActions>
                    <Certificate name="Certificate" onDownload={handleDownload} label="Download" />
                </CardActions>
                <MediaViewer
                    fileMimeType="application/pdf"
                    url={`${serviceURL}/api/ctms/1.0.0/mytraining/accomplishments/${match.params.id}/download`}
                />
            </Card>
        </Container>
    );
}
